export default {
  fields: {
    code: 'Code',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Type de remise',
    discount: 'Remise',
    usage_threshold: "Seuil d'utilisation",
    quantity: 'Quantité',
    expires_at: 'Expire',
    customers: 'Clients',
    purchases: 'Commandes',
    sales: 'Ventes',
    level: 'Niveau',
    max_discount: 'Remise maximale',
  },
  tags: {
    master: 'Maître',
    campaign: 'Campagne',
    one_time: 'Usage unique',
  },
  types: {
    single_use: 'Usage unique',
    multi_use: 'Multi-usage',
    unknown: 'Inconnu',
  },
  discount_types: {
    fixed_amount: 'Montant fixe',
    percentage: 'Pourcentage',
    unknown: 'Inconnu',
  },
  labels: {
    discount: 'Remise',
    usage_threshold: "Seuil d'utilisation",
    company: 'Société',
  },
  collecting_emails: {
    description:
      'Ici, vous pouvez configurer le code promo à usage unique généré pour les nouveaux utilisateurs lors de leur inscription sur le site.',
  },
  buttons: {
    edit: 'Modifier',
  },
  toasts: {
    successfully_deleted: 'Paramètres du code promo supprimés avec succès',
    failed_to_load_data: 'Échec du chargement des données',
  },
};
